import React from 'react';
import { InputText } from '@scotia/canvas-react';
import PropTypes from 'prop-types';

/** This AmountInput component was designed to be used in forms where an input text with $X.XXX format is needed.
 *
 * **For instance**: **123456** is become **$123.456**
 *
 * The Component accept a onChange function props that receive a amount by params
 *
 * **For instance**: The input show **$123.456** and the onChange function receive **123456**
 */
const AmountInput = props => {
  const maskInput = value => {
    const valueClean = ('' + value).split('');
    const amountPoints =
      valueClean.length % 3 === 0
        ? parseInt(valueClean.length / 3) - 1
        : parseInt(valueClean.length / 3);
    if (amountPoints !== 0) {
      for (let i = 1; i <= amountPoints; i++) {
        valueClean.splice(valueClean.length - (i - 1) - 3 * i, 0, '.');
      }
    }
    valueClean.length !== 0 && valueClean.splice(0, 0, '$');
    return valueClean.join('');
  };

  const justNumber = value => {
    const valueAux = ('' + value).replace(/\D+/g, '');
    return !isNaN(parseInt(valueAux)) ? parseInt(valueAux) : '';
  };

  const handleChange = ev => {
    props.onChange && props.onChange(justNumber(ev.target.value));
  };

  const amountWithDots =
    props.amount !== undefined ? maskInput(justNumber(props.amount)) : '';

  return amountWithDots !== '$0' ? (
    <InputText
      {...props}
      maxLength={props.maxLength}
      label={props.label}
      placeholder={props.placeholder}
      name="amount"
      onChange={ev => handleChange(ev)}
      value={amountWithDots}
    />
  ) : (
    <InputText
      {...props}
      maxLength={props.maxLength}
      error={true}
      errorMsg="El monto ingresado es inferior al mínimo"
      label={props.label}
      placeholder={props.placeholder}
      name="amount"
      onChange={ev => handleChange(ev)}
      value={amountWithDots}
    />
  );
};

AmountInput.propTypes = {
  /** The amount, usually the state of app */
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** Function called when input change, usually change the state of app */
  onChange: PropTypes.func.isRequired,
  /**Label of the input */
  label: PropTypes.string,
  /**Placeholder of the input */
  placeholder: PropTypes.string,
  /**Max Length of the input */
  maxLength: PropTypes.number
};

AmountInput.defaultProps = {
  label: 'Monto',
  placeholder: '$',
  maxLength: 16
};

export default AmountInput;
